module.exports = __webpack_public_path__ + "img/instruction.276d2537.png";